import { Chart, Grid, RectangleStackIcon } from 'components'
import { isEmpty } from 'lodash-es'
import { StatTile } from '..'
import { Aggregation, limitAggregationData, useAggregations } from '../../utils/analyticsUtils'
import { useWorkspaceAnalytics } from './WorkspaceAnalyticsProvider'

export default function WorkspaceAnalyticsUserTraitsSection() {
  const { dateRange } = useWorkspaceAnalytics()
  const { aggregations } = useAggregations(
    [
      {
        table: 'sessionTraits',
        values: ['_count'],
        categories: ['groupTitle', 'title'],
        sort: { _count: 'DESC' },
      },
    ],
    { dateRange }
  )

  const dataByGroup = aggregations[0]?.data?.reduce(
    (acc, cur) => {
      const group = cur.groupTitle || 'Other'
      if (!acc[group]) acc[group] = { ...aggregations[0], categories: ['title'], data: [] }
      acc[group].data!.push(cur)
      return acc
    },
    {} as Record<string, Aggregation>
  )

  if (isEmpty(dataByGroup)) return null

  return (
    <Grid templateColumns={`repeat(auto-fill, minmax(350px, 1fr))`} gap={6}>
      {Object.entries(dataByGroup).map(
        ([group, aggregation]) =>
          !!aggregation.data?.length && (
            <StatTile
              h="345px"
              key={group}
              alignItems="stretch"
              label={group}
              Icon={RectangleStackIcon}
              canCopy
            >
              <Chart {...aggregation} data={limitAggregationData(aggregation)} />
            </StatTile>
          )
      )}
    </Grid>
  )
}
